// NOTE: to future maintainers: it's something of an antipattern to return JSX from a hook, but in this
// case we were doing it for DX reasons, where we wanted to use a familiar API for creating toasts.
import { useCallback } from 'react';
import { toast as sonnerToast } from 'sonner';
import type { ToastProps } from '../../private/components/Toast';
import { Toast } from '../../private/components/Toast';

type Position =
  | 'bottom-center'
  | 'bottom-left'
  | 'bottom-right'
  | 'top-center'
  | 'top-left'
  | 'top-right';

export type UseToastProps = ToastProps & {
  position?: Position;
  duration?: number;
};

export type UseToastReturnType = ({
  message,
  icon,
  colorScheme,
  action,
  position,
  duration,
}: UseToastProps) => void;

export const useToast = (): UseToastReturnType => {
  return useCallback(
    ({ message, action, colorScheme, icon, position = 'bottom-left', duration = 3000 }) => {
      sonnerToast.custom(
        () => {
          return (
            <Toast
              action={action}
              colorScheme={colorScheme}
              icon={icon}
              message={message}
            />
          );
        },
        { position, duration },
      );
    },
    [],
  );
};
